import { useTheme, useMediaQuery } from '@mui/material';

/**
 * Custom hook for detecting device type based on viewport width.
 * Uses Material-UI's breakpoint system for consistency.
 *
 * Breakpoints:
 * - Mobile: 0-600px (xs to sm)
 * - Tablet: 600-900px (sm to md)
 * - Desktop: 900px+ (md and above)
 */
export const useMobileDetect = () => {
  const theme = useTheme();

  // Mobile: screens smaller than 'sm' breakpoint (600px)
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  // Tablet: screens between 'sm' and 'md' breakpoints (600-900px)
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));

  // Desktop: screens 'md' breakpoint and above (900px+)
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

  // Combined check for any small screen (mobile or tablet)
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));

  return {
    isMobile,
    isTablet,
    isDesktop,
    isSmallScreen
  };
};

export default useMobileDetect;
